<app-nav *ngIf="!_navService.isIframe"></app-nav>


<div class="page-layout mx-auto">

  <!-- LEFT SIDE MENU -->
  <aside class="side-menu">
    <ul>
      <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
        <a href="/admin/dashboard">
          <i class="fa fa-tachometer" aria-hidden="true"></i>
          Dashboard
        </a>
      </li>

      <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
        <a routerLink="/admin/discontinued">
          <i class="fa fa-archive" aria-hidden="true"></i>
          Discontinued
        </a>
      </li>

      <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
        <a routerLink="/admin/clearance">
          <i class="fa fa-tag" aria-hidden="true"></i>
          Clearance
        </a>
      </li>

      <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
        <a routerLink="/admin/stock-check">
          <i class="fa fa-tag" aria-hidden="true"></i>
          Stock Level Check
        </a>
      </li>

      <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
        <a routerLink="/admin/quotes">
          <i class="fa fa-book" aria-hidden="true"></i>
          Quotes
        </a>
      </li>

      <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
        <a routerLink="/admin/orders">
          <i class="fa fa-cart-plus" aria-hidden="true"></i>
          Orders
        </a>
      </li>

      <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" *ngIf="isFotiouAdmin || isCustomerService">
        <a routerLink="/admin/customers">
          <i class="fa fa-users" aria-hidden="true"></i>
          Customers
        </a>
      </li>

      <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" *ngIf="isFotiouAdmin || isCustomerAdmin">
        <a routerLink="/admin/members">
          <i class="fa fa-users" aria-hidden="true"></i>
          Members
        </a>
      </li>

      <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" *ngIf="isFotiouAdmin">
        <a routerLink="/admin/account-request">
          <i class="fa fa-thumbs-up" aria-hidden="true"></i>
          New Requests
        </a>
      </li>

      <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
        <a routerLink="/admin/account-setting">
          <i class="fa fa-cog" aria-hidden="true"></i>
          Account Settings
        </a>
      </li>

      <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
        <a (click)="_navService.logout()">
          <i class="fa fa-sign-out" aria-hidden="true"></i>
          Sign Out
        </a>
      </li>
    </ul>
  </aside>


  <!-- LEFT SIDE MENU -->
  <!--<aside class="side-menu" *ngIf="isLoggedIn">
    <ul>
      <ng-container *ngIf="isFotiouAdmin || isCustomerAdmin">
        <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
          <a class="nav-link" href="/admin/dashboard">Dashboard</a>
        </li>
        <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
          <a class="nav-link" routerLink="/admin/discontinued">Discontinued</a>
        </li>
        <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
          <a class="nav-link" routerLink="/admin/clearance">Clearance</a>
        </li>
        <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
          <a class="nav-link" routerLink="/admin/quotes">Quotes</a>
        </li>
        <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
          <a class="nav-link" routerLink="/admin/orders">Orders</a>
        </li>
        <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" *ngIf="isFotiouAdmin">
          <a class="nav-link" routerLink="/admin/customers">Customers</a>
        </li>
        <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
          <a class="nav-link" routerLink="/admin/members">Members</a>
        </li>
        <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" *ngIf="isFotiouAdmin">
          <a class="nav-link" routerLink="/admin/account-request">New Requests</a>
        </li>
        <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
          <a class="nav-link" routerLink="/account-setting/settings">Account Settings</a>
        </li>
      </ng-container>
      <ng-container *ngIf="isCustomerService">
        <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
          <a class="nav-link" href="/admin/dashboard">Dashboard</a>
        </li>
        <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
          <a class="nav-link" routerLink="/admin/discontinued">Discontinued</a>
        </li>
        <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
          <a class="nav-link" routerLink="/admin/clearance">Clearance</a>
        </li>
        <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
          <a class="nav-link" routerLink="/admin/quotes">Quotes</a>
        </li>
        <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
          <a class="nav-link" routerLink="/admin/orders">Orders</a>
        </li>
        <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
          <a class="nav-link" routerLink="/admin/customers">Customers</a>
        </li>
        <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
          <a class="nav-link" routerLink="/account-setting/settings">Account Settings</a>
        </li>
      </ng-container>
    </ul>
  </aside>-->
  <!-- MAIN CONTENT AREA -->
  <main class="main-content">
    <router-outlet></router-outlet>
  </main>
</div>


<!--<app-admin-sidebar></app-admin-sidebar>
<router-outlet></router-outlet>-->
